var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.121 15.879a3 3 0 0 1 0 4.242L25.394 32.849a3 3 0 0 1-3.668.446 3 3 0 0 1-.348-.24 3 3 0 0 1-.227-.207L8.422 20.121a3 3 0 0 1 4.243-4.242l10.608 10.606L33.879 15.88a3 3 0 0 1 4.242 0"
  })));
};
export default SvgIconChevronDown;